export default __webpack_public_path__ + "static/cw-image-e053295491ec352855a3563c29889d9a.webp";